export class cartManager {
    binded = {};
    constructor() {
        this.binded = {};
    }
    bind(name, callback) {
        this.binded[name] = this.binded[name] || [];
        this.binded[name].push(callback);
        return this.binded[name].length - 1;
    }
    unbind(name, index) {
        if (this.binded[name] && this.binded[name][index]) {
            this.binded[name].splice(index, 1);
        }
    }
    triggerEvent(name, cart) {
        if (this.binded[name]) {
            this.binded[name].forEach(callback => {
                callback(cart);
            });
        }
    }
    add(items, payload) {
        return new Promise((resolve, reject) => {
            this.deleteLocal();
            payload = payload || {};
            payload.items = items;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(cart => {
                    this.saveLocal(cart);
                    this.triggerEvent('added', items);
                    this.triggerEvent('updated', cart);
                    resolve(cart);
                })
                .catch(error => reject(error));
        });
    }
    update(items, payload) {
        return new Promise((resolve, reject) => {
            this.deleteLocal();
            payload = payload || {};
            payload.items = items;
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(cart => {
                    this.saveLocal(cart);
                    this.triggerEvent('updated', cart);
                    resolve(cart);
                })
                .catch(error => reject(error));
        });
    }
    emptyCart() {
        return new Promise((resolve, reject) => {
            this.deleteLocal();
            fetch('/cart/clear.js')
                .then(response => response.json())
                .then(cart => {
                    this.saveLocal(cart);
                    this.triggerEvent('updated', cart);
                    resolve(cart);
                })
                .catch(error => reject(error));
        });
    }
    removeItem(item) {
        return new Promise((resolve, reject) => {
            this.deleteLocal();
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ line })
            })
                .then(response => response.json())
                .then(cart => {
                    this.saveLocal(cart);
                    this.triggerEvent('removed', item);
                    this.triggerEvent('updated', cart);
                    resolve(cart);
                })
                .catch(error => reject(error));
        });
    }
    get() {
        return new Promise((resolve, reject) => {
            let cart = null;
            try {
                cart = this.getLocal();
            } catch (error) {
                console.log('🍨get local cart error', error);
                cart = null;
            }
            if (cart) {
                return resolve(cart);
            } else {
                return this.getRemote().then(resolve, reject);
            }
        });
    }
    deleteLocal() {
        localStorage.removeItem('cart');
        localStorage.removeItem('cartExpirationDate');
    }
    getLocal() {
        const expirationDate = localStorage.getItem('cartExpirationDate');
        if (expirationDate && expirationDate > new Date().getTime()) {
            return JSON.parse(localStorage.getItem('cart')) || [];
        }
    }
    saveLocal(cart) {
        const expirationDate = new Date();
        localStorage.setItem('cartExpirationDate', expirationDate.getTime() + 500);
        localStorage.setItem('cart', JSON.stringify(cart));
    }
    getRemote() {
        this.deleteLocal();
        return new Promise((resolve, reject) => {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    this.saveLocal(cart);
                    this.triggerEvent('updated', cart);
                    resolve(cart)
                })
                .catch(error => reject(error));
        });
    }

}
export default cartManager;